export default "__VITE_ASSET__2c4e9d04__"